import { render, staticRenderFns } from "./HorizontalLayoutMoreContent.vue?vue&type=template&id=6983143e&scoped=true"
import script from "./HorizontalLayoutMoreContent.vue?vue&type=script&lang=js"
export * from "./HorizontalLayoutMoreContent.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLayoutMoreContent.vue?vue&type=style&index=0&id=6983143e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6983143e",
  null
  
)

export default component.exports